import { useDispatch } from 'react-redux';
import React, { useCallback } from 'react';

import { manageColumnConfiguration } from '../../../store/orders/grid/orders.grid.actions';
import EditColumnsButton from '../index';
import { EditColumnsModalWrapper } from '../../../containers/edit-order-columns-modal-container';
import { useModal } from '../../../hooks/use-modal';

const EditOrdersGridColumnsButton = () => {
  const dispatch = useDispatch();
  const { close, isOpen, open } = useModal();
  const onClick = useCallback(() => {
    open();
    // For AnalyticsService
    dispatch(manageColumnConfiguration());
  }, [dispatch, open]);

  return (
    <React.Fragment>
      <EditColumnsButton onClick={onClick} />
      {isOpen && <EditColumnsModalWrapper onClose={close} />}
    </React.Fragment>
  );
};

export default EditOrdersGridColumnsButton;
